<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>

        <subNav></subNav>
        <div class="pressReleases">
            <div class="wrap presentations">
                <div class="title">Events</div>
                <div class="rf-itemlist">
                    <!-- <div :class="cItem1"><span @click="changeItem(1)">SEC Filings</span></div>
                    <div :class="cItem2"><span @click="changeItem(2)">Annual/Interim Reports</span></div>
                    <div class="clear"></div> -->
                    <eventsNav></eventsNav>
                </div>
                <div class="event-content">
                    <div class="caption">
                        <span class="date">Date</span>
                        <span class="details">Event Details</span>
                    </div>
                    <ul>
                        <li v-for="(item, index) in eventsList" :key="index">
                            <div class="date">{{ item.datetime }}</div>
                            <div class="right-event">
                                <div class="sub-title" style="margin-bottom: 10px; width: auto; float: left;">
                                    {{ item.title }}
                                </div>
                                <!-- <div class="voice">
                                    <img
                                        src="@/assets/investor-Relation/voice.png"
                                        alt=""
                                    />&nbsp;&nbsp;Click Here for Webcast
                                </div> -->
                                <div
                                    class="img"
                                    v-for="(cur, i) in item.files_path"
                                    :key="i"
                                    style="width: auto; float: left; padding-left: 20px;">
                                    <a :href="cur">
                                        <img
                                            src="@/assets/investor-Relation/pdf.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) == 'pdf'
                                            "
                                        />
                                        <img
                                            src="@/assets/investor-Relation/rar.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) ==
                                                    'rar' ||
                                                getFile(cur) == 'zip'
                                            "
                                        />
                                        <img
                                            src="@/assets/investor-Relation/rtf.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) == 'rtf'
                                            "
                                        />
                                        <img
                                            src="@/assets/investor-Relation/word.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) ==
                                                'word'
                                            "
                                        />
                                        <img
                                            src="@/assets/investor-Relation/xlsx.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) ==
                                                'xlsx'
                                            "
                                        />
                                        <img
                                            src="@/assets/investor-Relation/img.png"
                                            alt=""
                                            v-if="
                                                getFile(cur) ==
                                                'jpg'|| getFile(cur) ==
                                                'png'
                                            "
                                        />
                                        <!-- <span>{{ curFragment(cur) }}</span> -->
                                    </a>
                                </div>
                                <div class="clear"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
import eventsNav from "@/components/eventsNav/eventsNav";
export default {
    name: "events",
    components: { footerBox, navBox, subNav,mapBox, eventsNav },
    data() {
        return {
            eventsList: [],
            loading: false,
        };
    },
    created() {
        this.loading = true;
        this.$http.getWebEvents("types=events&pagesize=2").then((res) => {
            this.eventsList = res;
            this.loading = false;
        });
    },
    methods: {
        curFragment(data) {
            let start = data.lastIndexOf("/");
            let end = data.lastIndexOf(".");
            let result = data.substring(start + 1, end);
            return result;
        },
        getFile(url){
            var site=url.lastIndexOf("\.");
            return url.substring(site+1,url.length)
        }
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}

/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.clear {
    clear: both;
}
//内容
.pressReleases {
    padding-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .rf-itemlist{
        width: 100%;
        height: 50px;
        padding: 0px 10px 10px 10px;
        text-align: center;
    }
    .rf-item{
        width: 20%;
        height: 100%;
        float: left;
        text-align: center;
        font-size: 20px;
        line-height: 30px;
    }
    .rf-item span{
        height: 40px;
        margin: auto;
        line-height: 40px;
        display: inline-block;
    }
    .active {
    }
    .active span {
        border-bottom: 2px #000000 solid;
    }
    
    .listItem {
        width: 45%;
        height: 50px;
        float: left;
        text-align: left;
    }

    .fileListBody {
        width: 48%;
        float: left;

        height: 145px;
        border-bottom: 1px solid #e9e9e9;
        span {
            display: inline-block;
        }
        .time {
            width: 150px;
            color: #333333;
            font-size: 14px;
            text-indent: 20px;
            height: 110px;
            line-height: 110px;
        }
        .num {
            width: 90px;
            height: 110px;
            line-height: 110px;
            color: #409EFF;
            font-family: 'Lucida Bright';
        }
        .michael {
            width: 165px;
            height: 145px;
            line-height: 145px;
            color: #333333;
            font-family: 'Lucida Bright';
        }
        .headline {
            color: #333333;
            font-size: 16px;
            width: 400px;
            height: 145px;;
            line-height: 30px;
            font-family: 'Lucida Bright';
        }
        .group {
            width: 155px;
            height: 145px;
            line-height: 145px;
            color: #333333;
            font-family: 'Lucida Bright';
        }
    }
    .fileItem {
        width: 100%;
        height: 80px;
        padding-top: 20px;
        .fileTypeIcon{
            width: 18%;
            float: left;
            height: 100%;
            .printer-pdf {
                img {
                    margin-left: 30px;
                    width: 22px;
                    height: 25px;
                }
            }
            padding: 10px 10px 0px 0px;
            line-height: 40px;
        }
        .fileTitle {
            width: 80%;
            float: left;
            height: 100%;
            line-height: 40px;
        }
    }
}
.presentations {
    margin-bottom: 200px;
    .title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
        padding: 70px 0 50px 0;
    }
    .event-content {
        border: 1px solid #dcdcdc;
        padding: 30px;
        .caption {
            width: 1145px;
            height: 30px;
            line-height: 30px;
            color: #f2f2f2;
            font-size: 15px;
            background: #283254;
            .date {
                width: 220px;
                display: inline-block;
                text-indent: 20px;
            }
        }
        ul {
            li {
                display: flex;
                padding: 20px 0;
                border-bottom: 1px solid #e9e9e9;
                .date {
                    width: 220px;
                    font-size: 13px;
                    color: #888888;
                    text-indent: 20px;
                }
                .right-event {
                    color: #333333;
                    width: 900px;
                    font-size: 16px;
                    font-family: 'Lucida Bright';
                    .voice {
                        margin-bottom: 35px;
                        margin-top: 10px;
                        img {
                            width: 21px;
                            height: 20px;
                        }
                    }
                    .img {
                        margin-bottom: 10px;
                        img {
                            width: 22px;
                            height: 25px;
                        }
                        span {
                            margin-left: 10px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
}
.clear { clear: both;}
.presentations .event-content .right-event .img span:hover {
    border-bottom: 1px solid #6a6a6a;
}
</style>